
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSlightlycloudyNightColour as ObiSlightlycloudyNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-slightlycloudy-night-colour.js';
 
 
 

 
 export const ObiSlightlycloudyNightColour = createComponent({
   react: React,
   tagName: 'obi-slightlycloudy-night-colour',
   elementClass: ObiSlightlycloudyNightColourElement,
   events: {
     
   }
  });
 
 